import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

export default new Vuex.Store({
	state:{
		name:"123"
	},
	login:{},
	mutations: {
		increment(state) {
			state.count++
		}
	}
})
